import { Banner } from '@sunwebgroup/uds-ui/banner'
import * as React from 'react'
import { useIntl } from '@/intl'

export function RoomSelectionEarlyBirdBanner() {
  const intl = useIntl()

  return (
    <Banner color="informative" hasIcon size="M" icon="FaceHappy">
      <Banner.ContentWrapper>
        <Banner.TextsWrapper>
          <Banner.Text>{intl.formatMessage({ id: 'groups_checkout_steps_room_selection_early_bird_banner_title' })}</Banner.Text>
          <Banner.SupportingText>
            {intl.formatMessage({ id: 'groups_checkout_steps_room_selection_early_bird_banner_text' })}
          </Banner.SupportingText>
        </Banner.TextsWrapper>
      </Banner.ContentWrapper>
    </Banner>
  )
}
